import styled from "styled-components";



export const InfoContainer = styled.div`
	background: #077adceb 0% 0% no-repeat padding-box !important;
  opacity: 1;

	@media screen and (max-width: 768px) {
		padding: 0 0;
	}

`;

export const InfoWrapper = styled.div`
	display: grid;
	z-index: 1;
	height: 600px;
	width: 100%;
	max-width: 1100px;
	margin-right: auto;
	margin-left: auto;
	justify-content: center;
  @media screen and (max-width: 1500px) {
		height: 650px;
	}
  @media screen and (max-width: 768px) {
		height: 700px;
    margin-right: 0;
    justify-content: left;
    padding-left: 3rem;
	}
`;

export const InfoRow = styled.div`
	display: grid;
	grid-auto-columns: minmax(auto, 1fr);
	grid-template-areas:  'col1 col2 col3';

	@media screen and (max-width: 768px) {
		grid-template-areas:  'col1' 'col2' 'col3';
    padding-left: 3rem;
	}
  @media screen and (max-width: 480px) {
		grid-template-areas:  'col1' 'col2' 'col3';
    padding-left: 0rem;
	}
`;

export const Column1 = styled.div`
  margin-top: 3rem;
	padding: 0 15px;
	grid-area: col1;
	display: flex;
  align-items: center;
  @media screen and (max-width: 768px) {
    padding: 0 50px;
	}
  @media screen and (max-width: 550px) {
		margin-top: 5rem;
    padding: 0;
    display: block;
    padding-left: 3.5rem;
	}
`;
export const Column2 = styled.div`
  margin-top: 3rem;
	padding: 0 15px;
	grid-area: col2;
	display: flex;
  align-items: center;
  @media screen and (max-width: 768px) {
		margin-top: -60px;
    padding: 0 50px;
	}
  @media screen and (max-width: 550px) {
    padding: 0;
    display: block;
    padding-left: 3.5rem;
	}
`;
export const Column3 = styled.div`
  margin-top: 3rem;
	padding: 0 15px;
	grid-area: col3;
	display: flex;
  align-items: center;
  @media screen and (max-width: 768px) {
		margin-top: -60px;
    padding: 0 50px;
	}
  @media screen and (max-width: 550px) {
    padding: 0;
    display: block;
    padding-left: 3.5rem;
	}
`;
export const TextWrapper = styled.div`
	max-width: 480px;
  display: -webkit-inline-box;
  margin-top: 5rem;

  @media screen and (max-width: 1500px) {
		margin-top: 0;
    max-width: 340px;
	}
  @media screen and (max-width: 768px) {
		margin-top: 0;
    max-width: 200px;
	}
  @media screen and (max-width: 600px) {
		margin-top: 0;
    max-width: 200px;
    display: grid;
    margin-left:0;
	}
`;

export const TopLine = styled.p`
	color: #383838;
	font-size: 16px;
  max-width: 350px;
	line-height: 16px;
	font-weight: bold;
	text-transform: uppercase;
	margin-bottom: 16px;
  text-align: left;
  letter-spacing: -0.53px;
  @media screen and (max-width: 768px){
		font-size: 14px;
	}
  @media screen and (max-width: 480px){
		font-size: 14px;
	}
`;

export const Heading = styled.h1`
	margin-bottom: 0rem;
  margin-left: 1rem;
	font: normal  normal bold 30px 'Spoqa Han Sans Neo';
	line-height: 1.1;
  width: 200px;
  color: #f2f7fb;
  position: absolute;
  padding-top: 70px;
	@media screen and (max-width: 768px){
		font-size: 28px;
    padding-left: 3rem;
	}
	@media screen and (max-width: 480px){
		font-size: 28px;
    padding-left: 0rem;

	}
`;

export const Subtitle = styled.p`
	max-width: 440px;
	font-size: 18px;
  color: #fff;
  font-weight: 300;
	line-height: 24px;
  opacity: 0.6;
  @media screen and (max-width: 1200px){
		font-size: 16px;
	}
  @media screen and (max-width: 768px){
		font-size: 12px;
	}
  @media screen and (max-width: 480px){
		font-size: 12px;
	}
`;

export const Boldtitle = styled.p`
	max-width: 440px;
	margin-bottom: 10px;
  text-align: left;
  font-weight: 500;
  font-size: 22px;
	line-height: 24px;
  color: #fff;
  @media screen and (max-width: 1200px){
		font-size: 18px;
    line-height: 0;
	}
  @media screen and (max-width: 768px){
		font-size: 15px;
	}
  @media screen and (max-width: 480px){
		font-size: 15px;
	}
`;

export const NumberFlex = styled.div`
  display: flex;
	width: -webkit-fill-available;
  @media screen and (max-width: 1500px) {
		margin: 0;
	}
`
export const Number = styled.div`
	margin-bottom: 24px;
	font-size:  64px ;
	line-height: 0.8;
  margin-right: 1rem;
  font-weight: lighter;
  font-family: 'Spoqa Han Sans Neo', 'sans-serif';
  color: #fff;
	@media screen and (max-width: 1500px){
		font-size: 50px;
    line-height: 0.5;
	}
	@media screen and (max-width: 768px){
		font-size: 28px;
	}
	@media screen and (max-width: 480px){
		font-size: 28px;
	}
`;
export const FirstNumber = styled.text`
  opacity: 0.6;
`;

export const BtnWrap = styled.div`
	display: flex;
	justify-content: flex-start;
`;

export const ImgWrap =styled.div`
  max-height: 550px;
  @media screen and (max-width: 1500px) {
		max-height: 320px;
	}
`;

export const Img = styled.img`
  margin-top: 5px;
  width: 220px;
  border-radius: 25px;
  @media screen and (max-width: 1500px){
		margin-left: 1rem;
    margin-top: 2rem;
    width: 170px;
    margin-bottom: 15px;
	}
  @media screen and (max-width: 768px){
    margin-top: 2rem;
    margin-bottom: 15px;
    width: 150px;
    margin-right: 2rem;
	}
  @media screen and (max-width: 550px){
		margin-left: 0rem;
    margin-top: 2rem;
    margin-bottom: 15px;
    width: 160px;
    margin-right: 1rem;
	}
`;
